<template>
  <v-snackbar
    v-model="open"
    :color="type"
    :multi-line="multi"
    :timeout="0"
    v-bind="$attrs"
    top
  >
    <div v-html="message" />
    <v-btn icon @click="close">
      <v-icon>mdi-close</v-icon>
    </v-btn>
  </v-snackbar>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { LEVEL } from '../../utils/log';

export default {
  data() {
    return {
      open: false,
      type: LEVEL.INFO,
      message: '',
      multi: false,
    };
  },

  computed: {
    ...mapState('app', [
      'messages',
    ]),
  },

  watch: {
    messages(messages, oldMessages) {
      if (_.isEmpty(messages) || messages.length < oldMessages.length) {
        return;
      }
      const { snack, level } = _.last(messages);
      this.type = level;
      this.message = snack.name ? `${snack.name}: ` : '';
      this.message += snack.message;
      this.show(true);
    },
  },

  methods: {
    ...mapActions('app', {
      acknowledgeLastSnack: 'popSnack',
    }),

    /**
     * Shows or hides the snackbar component.
     *
     * @param {boolean} open Show or hide the component.
     */
    show(open) {
      this.multi = this.message.indexOf('\n') !== -1;
      this.message = this.message.replace('\n', '<br>');
      const timeout = this.type === LEVEL.ERROR ? 0 : (this.message.length * 250);

      if (this.type !== LEVEL.ERROR) {
        // TODO fix closing success snack
        let toCloseId;
        if (this.messages.length > 0) { // temporary fix
          toCloseId = _.last(this.messages).id;
        }
        setTimeout(() => {
          if (toCloseId === _.get(_.last(this.messages), 'id')) {
            this.close();
          }
        }, timeout);
      }
      this.open = open;
    },

    /**
     * Shows a success type message snackbar.
     *
     * @param {string} message Message to display in the component.
     */
    success(message) {
      this.type = LEVEL.SUCCESS;
      this.message = message;
      this.show(true);
    },

    /**
     * Shows a warning type message snackbar.
     *
     * @param {string} message Message to display in the component.
     */
    warn(message) {
      this.type = LEVEL.WARNING;
      this.message = message;
      this.show(true);
    },

    /**
     * Shows an error type message snackbar.
     *
     * @param {string} message Message to display in the component.
     */
    error(message) {
      this.type = LEVEL.ERROR;
      this.message = message;
      this.show(true);
    },

    /**
     * Closes the snackbar component.
     */
    close() {
      this.show(false);
      this.acknowledgeLastSnack();
    },
  },
};
</script>
